export default __webpack_public_path__ + "static/media/45.fd97ae1d.jpg";